import React, { useRef, useState } from "react";

import { Volume2, VolumeX } from "lucide-react";

interface VideoCardProps {
  src: string;
  title: string;
  calendly: string;
}

const VideoCard: React.FC<VideoCardProps> = ({ src, title, calendly }) => {
  const [usedSrc, setUsedSrc] = useState(src);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [isMuted, setIsMuted] = useState(true);

  const ytCommand = (func: "mute" | "unMute") => {
    const msg = JSON.stringify({ event: "command", func, args: [] });
    // You can replace '*' with 'https://www.youtube.com' if you also add &origin=<your origin> in src
    iframeRef.current?.contentWindow?.postMessage(msg, "*");
  };

  const toggleMute = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (isMuted) ytCommand("unMute");
    else ytCommand("mute");
    setIsMuted((v) => !v);
  };
  return (
    <div className="relative w-full aspect-video rounded-xl overflow-hidden bg-black group">
      {/* Video */}
      <iframe
        ref={iframeRef}
        className="absolute  pointer-events-none select-none inset-0 w-full h-full"
        src={usedSrc}
        title={title}
        frameBorder="0"
        allow="autoplay;  encrypted-media; picture-in-picture"
        allowFullScreen
        onLoad={() => ytCommand("mute")}
      />
      <div className="absolute pointer-events-none bg-gradient-to-t from-black/70 via-black/30 to-transparent w-full  bottom-0 p-4">
        <div className="flex items-center justify-between">
          <h3 className="text-base font-bold leading-snug">{title}</h3>
        </div>
      </div>
      <button
        onClick={toggleMute}
        className=" h-16 w-16 !z-10 right-10 bottom-10  absolute flex flex-col justify-center items-center rounded-full bg-black/50 hover:bg-black/70 active:scale-95 transition"
        aria-label={isMuted ? "Unmute video" : "Mute video"}
      >
        {isMuted ? (
          <VolumeX className="w-8 h-8 !cursor-pointer text-white" />
        ) : (
          <Volume2 className="w-8 h-8 !cursor-pointer text-white" />
        )}
      </button>
    </div>
  );
};

const VideoGrid: React.FC = () => {
	const videos: VideoCardProps[] = [
		{
			src: "https://www.youtube.com/embed/ku4Rg_NRomM?controls=0&autoplay=1&mute=1&loop=1&enablejsapi=1",
			title: "25% Leads to Sales Meeting Conversion Rate",
			calendly: "https://calendly.com/your-link-1",
		},
		{
			src: "https://www.youtube.com/embed/XRqUZpjGJPg?controls=0&autoplay=1&mute=1&loop=1&enablejsapi=1",
			title: "Quickly Talking Business vs. Starting From Zero",
			calendly: "https://calendly.com/your-link-2",
		},
		{
			src: "https://www.youtube.com/embed/ip2yemg-ibs?controls=0&autoplay=1&mute=1&loop=1&enablejsapi=1",
			title: "Real People, writing real messages, customized for clients",
			calendly: "https://calendly.com/your-link-3",
		},
		{
			src: "https://www.youtube.com/embed/ijWOUABvgHY?controls=0&autoplay=1&mute=1&loop=1&enablejsapi=1",
			title: "Booked a 3 Times Bigger Client than Average Clients",
			calendly: "https://calendly.com/your-link-4",
		},
		{
			src: "https://www.youtube.com/embed/iyOCyqrpz4M?controls=0&autoplay=1&mute=1&loop=1&enablejsapi=1",
			title: "17% Engagement Rate on Campaign Outreach",
			calendly: "https://calendly.com/your-link-5",
		},
		{
			src: "https://www.youtube.com/embed/X2W1UtWQ56U?controls=0&autoplay=1&loop=1&mute=1&enablejsapi=1",
			title: "Outreach, Graphics, Copy, Data – They’re doing everything",
			calendly: "https://calendly.com/your-link-6",
		},
	];

	return (
		<div className="grid grid-cols-1 md:grid-cols-2  lg:grid-cols-3 mt-10 gap-10">
			{videos.map((video, idx) => (
				<VideoCard key={idx} {...video} />
			))}
		</div>
	);
};

const TopBrands = () => {
	return (
		<section className="bg-[#EDF8FF]  mt-10 w-full py-8 lg:py-20">
			<div className="max-w-[1400px] mx-auto container px-8 sm:px-12">
				<h1 className="text-2xl lg:text-[3rem]  text-black text-center mb-10">
					See How We’ve Helped Top Brands
				</h1>
				<VideoGrid />

				<a
					href="#calendly-widget"
					// onClick={() => setIsFormOpen(true)}
					className="bg-brand-green text-white flex max-md:w-fit   justify-center items-center text-xl  lg:w-[20%]  mx-auto mt-10 h-16 rounded-full px-12 border border-brand-green hover:border-black hover:bg-white hover:text-brand-green transition-all duration-200 ease-in-out whitespace-nowrap"
				>
					Book a Meeting
				</a>
			</div>
		</section>
	);
};
export default TopBrands;
